module.exports = __webpack_public_path__ + "static/box_3-d5200a62c52c66447a465556f4c0d825.png";